import {useMutation} from '@tanstack/react-query';
import {useCallback} from 'react';
import {ticketMutationAdapter} from '../../../../adapter/ticketMutationAdapter';
import {AttemptToBuyTicketInfo} from '../type';

export function useBuyTicketMutationHandler() {
  const {mutateAsync} = useMutation(ticketMutationAdapter.buyTicket());

  const handleBuyTicketAsyncMutation = useCallback(
    async (attemptToBuyTicketInfo: AttemptToBuyTicketInfo) => {
      const seriesId = attemptToBuyTicketInfo.seriesId;
      const ticketKind = attemptToBuyTicketInfo.ticketKind;
      const ticketList =
        'chunkList' in attemptToBuyTicketInfo
          ? attemptToBuyTicketInfo.chunkList.map(chunk => ({
              ticketId: chunk.ticket.ticketId,
              quantity: chunk.quantity,
            }))
          : [
              {
                ticketId: attemptToBuyTicketInfo.ticketId,
                quantity: attemptToBuyTicketInfo.quantity,
              },
            ];
      const ticketBuyMutationInput = {
        seriesId,
        ticketKind,
        ticketList,
      };

      return await mutateAsync({
        input: ticketBuyMutationInput,
      });
    },
    [mutateAsync]
  );

  return {
    handleBuyTicketAsyncMutation,
  };
}
